// Development auto-authentication utility (optional)
//
// To enable, provide a JWT at runtime via Vite env:
//   VITE_DEV_JWT_TOKEN
//
// IMPORTANT:
// - Never commit real tokens.
// - This helper only runs on localhost/dev domains.

const DEV_JWT_TOKEN = (import.meta.env.VITE_DEV_JWT_TOKEN || '') as string;

export function setupDevAuth() {
  const hostname = window.location.hostname;
  const isDevDomain = hostname === 'dev.devcockpit.ai';
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isDev = import.meta.env.DEV || isDevDomain || isLocalhost;

  if (!isDev) return;
  if (!DEV_JWT_TOKEN) return;

  localStorage.setItem(
    'dc.auth',
    JSON.stringify({
      token: DEV_JWT_TOKEN,
      timestamp: Date.now(),
    })
  );

  localStorage.setItem('dc.persist', 'true');

  // Trigger a storage event to update any listening components
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: 'dc.auth',
      newValue: localStorage.getItem('dc.auth'),
    })
  );
}

// Initialize dev auth when module is imported
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDevAuth);
  } else {
    setupDevAuth();
  }
}
